import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { NotificationType, SapNotification } from "./types";
import { showNotificationBase } from "./notification-service";

export interface CoreState {
    globalError?: string;
    isMobile?: boolean;
    appInitialized: boolean;
    notifications: SapNotification[];
}

const initialState: CoreState = { appInitialized: false, notifications: [] };

export const coreSlice = createSlice({
    name: "core",
    initialState,
    reducers: {
        setGlobalError: (state, action: PayloadAction<string>) => {
            state.globalError = action.payload;
        },
        setIsMobile: (state, action: PayloadAction<boolean>) => {
            state.isMobile = action.payload;
        },
        setAppInitialized: (state, action: PayloadAction<boolean>) => {
            state.appInitialized = action.payload;
        },
        showToast: (state, action: PayloadAction<SapNotification>) => {
            state.notifications.push(action.payload);
        },
        dismissToast: (state, action: PayloadAction<string>) => {
            const index = state.notifications.findIndex((n) => n.id == action.payload);
            state.notifications.splice(index, 1);
        },
    },
});

export const { setGlobalError, setIsMobile, setAppInitialized, dismissToast, showToast } = coreSlice.actions;

export const globalErrorSelector = (state: RootState) => state.core.globalError;
export const isMobileSelector = (state: RootState) => state.core.isMobile;
export const notificationSelector = (state: RootState) => state.core.notifications;

export default coreSlice.reducer;

export function withErrorHandler<TArg, TResult>(apiFn: (arg: TArg) => Promise<TResult>) {
    return async (
        arg: TArg,
        { dispatch, rejectWithValue }: { dispatch: any; rejectWithValue: (msg: string) => any }
    ): Promise<TResult | ReturnType<typeof rejectWithValue>> => {
        try {
            return await apiFn(arg);
        } catch (error: any) {
            const errorMsg = error.response?.data?.message || error.message || "Unknown error";
            showNotificationBase(dispatch, NotificationType.error, errorMsg);
            return rejectWithValue(errorMsg);
        }
    };
}
